import styled from '@emotion/styled';
import * as c from '@identity/constants';
import { remCalc } from '@lib/styleMethods';
import TypeScale from '@identity/type';

export const Grid = styled.section`
  margin-top: 80px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100%, 300px));
  grid-gap: 50px;
  justify-content: center;

  ${c.TABLET} {
    grid-template-columns: repeat(auto-fill, minmax(300px, 300px));
  }
`;

export const GridImageWrapper = styled.figure`
  transition: box-shadow 300ms;
  :hover {
    box-shadow: 0px 21px 41px -20px rgba(0, 0, 0, 0.84);
  }
  width: 300px;
  height: 300px;
  position: relative;
`;

export const Title = styled.div`
  ${c.TABLET} {
    h1::before,
    h1::after {
      display: inline-block;
      content: '';
      border-top: 1px solid ${c.colors.PRIMARY_004};
      width: 75px;
      margin: 0 1rem;
      transform: translateY(-1rem);
    }
  }
`;
